// OneTrust OptanonConsent.groups encodes categories as "<id>:<0|1>". 4:1 = advertising opted in.
// TODO(WEB-207389): confirm 4 is our tenant's advertising category id before GA.
export const ONETRUST_ADVERTISING_GROUP_OPTED_IN = '4:1' as const;

export const ONETRUST_CONSENT_COOKIE = 'OptanonConsent' as const;

export const AKAMAI_COUNTRY_COOKIE = 'akmCC' as const;

export const LAUNCH_OPTIN_STATUS_VAR = 'user_optin_status' as const;

export const LAUNCH_OPTIN = 'optin' as const;
export const LAUNCH_OPTOUT = 'optout' as const;

// GDPR / GDPR-like countries default to opt-out. Source: WEB-207389.
export const OPT_OUT_COUNTRIES: ReadonlySet<string> = new Set([
  'AU',
  'AT',
  'BE',
  'BR',
  'BG',
  'CN',
  'CO',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IL',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PH',
  'PL',
  'PT',
  'CY',
  'RO',
  'RU',
  'SG',
  'SK',
  'SI',
  'KR',
  'ES',
  'SE',
  'CH',
  'GB',
  'UA',
]);
